import { MiChip } from "@miplatform/components";
import { useTheme } from "@mui/material";

const PLAN_STATUS = {
  ACTIVE: "Active",
  DRAFT: "Draft",
};

export function StatusChip({ status }: StatusChipProps) {
  const theme = useTheme();

  const getChipStyle = () => {
    let color = "";
    let backgroundColor = "";
    let borderColor = "";

    switch (status) {
      case PLAN_STATUS.ACTIVE:
        color = theme.palette.common.white;
        backgroundColor = theme.palette.green.main;
        borderColor = theme.palette.green.dark;
        break;
      case PLAN_STATUS.DRAFT:
        color = theme.palette.common.white;
        backgroundColor = theme.palette.orange.main;
        borderColor = theme.palette.orange.dark;
        break;
      default:
        break;
    }

    return {
      border: `1px solid ${borderColor}`,
      color,
      backgroundColor,
      borderRadius: 1,
      height: 18,
      fontWeight: theme.fontWeight.regular,
    };
  };

  return <MiChip label={status} size="small" sx={getChipStyle()} />;
}

interface StatusChipProps {
  status: string;
}
